import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = { class: "symbol-label fs-3 bg-light-danger text-danger" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_13 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_14 = { class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" }
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = { class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2 me-5" }
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = { class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2" }
const _hoisted_19 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_20 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_21 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Business ID", -1)
const _hoisted_27 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_28 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Overview ")
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" User Management ")
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Subscriptions ")
const _hoisted_35 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" API Keys ")
const _hoisted_37 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Billing ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user?.first_name?.[0] || "-") + " " + _toDisplayString(_ctx.user?.last_name ? _ctx.user.last_name[0] : ""), 1),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.user?.fullname), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user?.user_type ? _ctx.userTypes[_ctx.user.user_type] : "User"), 1)
                  ]),
                  _createElementVNode("span", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user?.email), 1)
                  ]),
                  _createElementVNode("span", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" Joined on " + _toDisplayString(_ctx.$filters.formatDate(_ctx.user?.date_joined)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.user?.business_id), 1)
                    ]),
                    _hoisted_26
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("ul", _hoisted_28, [
            _createElementVNode("li", _hoisted_29, [
              _createVNode(_component_router_link, {
                to: _ctx.profileUrl,
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (!_ctx.isClientUser)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", _hoisted_31, [
                    _createVNode(_component_router_link, {
                      to: _ctx.usersUrl,
                      class: "nav-link text-active-primary me-6",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", _hoisted_33, [
                    _createVNode(_component_router_link, {
                      to: _ctx.subscriptionsUrl,
                      class: "nav-link text-active-primary me-6",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  (_ctx.isCompanyUser)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                        _createVNode(_component_router_link, {
                          to: _ctx.keysUrl,
                          class: "nav-link text-active-primary me-6",
                          "active-class": "active"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isCompanyUser)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                        _createVNode(_component_router_link, {
                          to: _ctx.billingsUrl,
                          class: "nav-link text-active-primary me-6",
                          "active-class": "active"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}